import React, { createContext, useContext, useState } from 'react';

interface ContextProps {
    currentStep: number;
    setCurrentStep(stepNumber: number): void;
}

const defaultState = {
    currentStep: 0,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setCurrentStep: (_stepNumber: number) => {},
};

const StepContext = createContext<ContextProps>(defaultState);

export const StepContextProvider: React.FC = ({ children }) => {
    const context = useProvideStepContext();

    return <StepContext.Provider value={context}>{children}</StepContext.Provider>;
};

export const useStepContext = () => {
    return useContext(StepContext);
};

function useProvideStepContext() {
    const [currentStep, setCurrentStep] = useState<ContextProps['currentStep']>(defaultState.currentStep);
    return {
        currentStep,
        setCurrentStep
    };
}
